import React from "react";

const Intro2 = ({ language }) => {
  const text = getText(language);
  return <div>{text}</div>;
};

const getText = (language) => {
  switch (language) {
    case "en":
      return (
        <>
          <p>
            The purpose of this app is to help establish whether you or your
            client are eligible to apply for settled status or pre-settled
            status under the EU Settlement Scheme.
          </p>
          <p>
            <strong>
              If you successfully apply for settled status this means that:
            </strong>
          </p>
          <ul>
            <li>
              You have the <strong>right to travel</strong> in and out of the UK{" "}
              <strong>and to remain</strong> in the UK permanently; regardless
              of whether you are exercising treaty rights in the UK. This means
              that you do not have to demonstrate that you are a student,
              working, self-employed, job-seeking or self-sufficient to remain
              in the UK.
            </li>
            <li>
              You can <strong>access and apply</strong> for healthcare,
              education, pensions and benefits on the same basis as a UK
              national. You will be subject to the same eligibility requirements
              as a UK national, but cannot be denied access to such benefits on
              the basis of your immigration status alone.
            </li>
            <li>
              You can{" "}
              <strong>
                engage in business, take or change employment, or be
                self-employed
              </strong>{" "}
              without the need for permission from a Government department.
            </li>
            <li>
              You can <strong>apply for British citizenship</strong> after
              living in the UK for one year from when you are granted settled
              status.
            </li>
            <li>
              <strong>If you have a child</strong> that is born in the UK whilst
              you are living here, they will automatically be a British citizen.
            </li>
            <li>
              You will <strong>lose your settled status</strong> if you spend 5
              years or more outside the UK at one time (although if you’re a
              Swiss citizen, you and your family can only spend up to 4 years in
              a row outside the UK before losing your settled status).
            </li>
            <li>
              Your <strong>close family members</strong> can join you in the UK
              before 31 December 2020 (or before 31 December 2025 if you’re a
              Swiss citizen) but they will need to apply under the EU Settlement
              Scheme. There are certain conditions under which they can join you
              after 31 December 2020, but you should write to us for specific
              advice on this question.
            </li>
          </ul>

          <p>
            <strong>
              If you successfully apply for pre-settled status this means that:
            </strong>
          </p>
          <ul>
            <li>
              You have the <strong>right to remain</strong> in the UK for five
              years.
            </li>
            <li>
              You <strong>do not have to be exercising treaty rights</strong> to
              remain in the UK. This means that you do not have to demonstrate
              that you are a student, working, self-employed, job-seeking or
              self-sufficient to remain in the UK.
            </li>
            <li>
              When you have been in the UK for five years, as long as you have
              not been outside the UK for six months in any of these years,{" "}
              <strong>you can then apply for settled status</strong>, even if
              this happens after 31 December 2020.
            </li>
            <li>
              You can{" "}
              <strong>spend up to 2 years in a row outside the UK</strong>{" "}
              without losing your status (although you should avoid absences of
              6 months or more if you hope to eventually apply for settled
              status, unless there is an important reason for the absence).
            </li>
            <li>
              <strong>If you have a child</strong> in the UK, they will
              automatically be eligible for pre-settled status (they will
              generally only be a British citizen if they qualify for this
              through their other parent who has British citizenship or settled
              status themselves).
            </li>
            <li>
              You will{" "}
              <strong>
                not automatically be eligible to claim benefits or access
                healthcare
              </strong>
              , education and pensions in the UK. You must still demonstrate
              that you are exercising a ‘qualifying right to reside’ i.e. that
              you have permanent residence, worker, self-employed or retained
              worker status, that you are the family member of an EU national in
              one of these categories, or that you are the primary carer of an
              EEA national worker’s child in education.
            </li>
          </ul>
        </>
      );
    case "bg":
      return (
        <>
          <p>
            Целта на тази апликация е да Ви помогне да прецените дали Вие или
            Вашият клиент отговоря на условията за кандидатстване за статут на
            уседналост или временен статут на уседналост по Схемата за
            уседналост на граждани на ЕС (EU Settlement Scheme)
          </p>
          <p>
            <strong>
              Ако вие получите статут на уседналост, това значи че:
            </strong>
          </p>
          <ul>
            <li>
              Имате право да пътувате в и извън Обединеното Кралство и да
              останете в Обединеното Кралство постоянно, независимо дали
              упражнявате права по договорите на ЕС в Обединеното Кралство. Това
              означава, че вие не трябва да доказвате, че сте ученик, работещ,
              самонает, търсещ работа или самостоятелно издържащо се лице, за да
              останете в Обединеното Кралство.
            </li>
            <li>
              Имате право на достъп и да кандидатствате за здравеопазване,
              образование, пенсия и помощи на същата основа като гражданин на
              Обединеното Кралство. Вие ще трябва да покриете същите изисквания
              като британски гражданин, но не може да Ви бъде отказано само въз
              основа на имиграционния Ви статут.
            </li>
            <li>
              Вие може да се занимавате с бизнес, започнете или смените работа,
              или да сте самонает без необходимост от разрешение от
              Правителството.
            </li>
            <li>
              Може да кандидатствате за британско гражданство 1 година след като
              сте получили статут на уседналост.
            </li>
            <li>
              Ако детето Ви се роди в Обединеното Кралство, докато живеете тук,
              то автоматично ще стане британски гражданин
            </li>
            <li>
              Ще изгубите статута си на уседналост, ако прекарате 5 или повече
              години наведнъж извън Обединеното Кралство (за граждани на
              Швейцария, Вие и Вашето семейство може да прекарате само 4 години
              преди да изгубите статута си).
            </li>
            <li>
              Близките членове на семейството Ви може да се присъединят към Вас
              в Обединеното Кралство преди 31 Декември 2020 (или ако сте
              гражданин на Швейцария - преди 31 Декември 2025), но те ще трябва
              да кандидатстват по Схемата за уседналост на ЕС. Има конкретни
              изисквания, въз основа на които те могат да се присъединят към Вас
              и след 31 Декември 2020, но трябва да ни пишете, за да получите
              съвет по този въпрос.
            </li>
          </ul>

          <p>
            <strong>
              Ако получите временен статут на уседналост, това значи че::
            </strong>
          </p>
          <ul>
            <li>Имате право да останете в Обединеното Кралство за 5 години.</li>
            <li>
              Не е необходимо да упражнявате права по договорите на ЕС, за да
              може да останете в Обединеното Кралство. Това означава, че вие не
              трябва да доказвате, че сте ученик, работещ, самонает, търсещ
              работа или самостоятелно издържащо се лице, за да останете в
              Обединеното Кралство.
            </li>
            <li>
              Когато сте били в Обединеното Кралство за 5 години и в случай, че
              не сте били извън Обединеното Кралство за повече от 6 месеца през
              която и да е от тези години, Вие може да кандидатствате за статут
              на уседналост тогава, дори и това да е след 31 Декември 2020.
            </li>
            <li>
              Може да прекарате до 2 години извън Обединеното Кралство без да
              загубите временния си статут на уседналост (но ако искате след
              това да кандидатствате за статут на уседналост, трябва да не
              бъдете извън Обединеното Кралство за 6 месеца или повече, освен
              ако няма важна причини за тези отсъствия).
            </li>
            <li>
              Ако Ви се роди дете в Обединеното Кралство, то автоматично има
              право на временен статут на уседналост (то ще бъдат автоматично
              британски граждани само ако другия му родител има британско
              гражданство или статут на уседналост).
            </li>
            <li>
              Вие нямате автоматично право да кандидатствате или получавате
              помощи, здравеопазване, образование и пенсии в Обединеното
              Кралство. Вие трябва да докажете, че упражнявате право на
              пребиваване, т.е. да имате права на постоянно пребиваване,
              работещ, ученик, самонает или запазено право на работещ; или сте
              член на семейството на някой, който отговаря на тези условия; или
              че сте основното лице, полагащо грижи за детето, което е учащо и е
              дете на работещ гражданин на страна от ЕС.
            </li>
          </ul>
        </>
      );
    case "it":
      return (
        <>
          <p>
            Lo scopo di questa app è di aiutare a stabilire se tu o il tuo
            cliente siete idonei a richiedere lo stato di residenza permanente o
            provvisoria dell'EU Settlement Scheme (programma di residenza per
            cittadini UE).
          </p>
          <p>
            <strong>
              Se richiedi con successo lo stato di residenza, ciò significa che:
            </strong>
          </p>
          <ul>
            <li>
              Hai il diritto di viaggiare all'interno e fuori dal Regno Unito e
              di rimanere nel Regno Unito in modo permanente; indipendentemente
              dal fatto che tu stia esercitando i diritti dei trattati nel Regno
              Unito. Ciò significa che non devi dimostrare di essere uno
              studente, un lavoratore, un lavoratore autonomo, in cerca di
              lavoro o autosufficiente per rimanere nel Regno Unito.
            </li>
            <li>
              Puoi accedere e richiedere assistenza sanitaria, istruzione,
              pensioni e sussidi sulla stessa base di un cittadino inglese.
              Sarai soggetto agli stessi requisiti di idoneità di un cittadino
              del Regno Unito, ma non ti potrà essere negato l'accesso a tali
              benefici solo sulla base del tuo stato di immigrazione.
            </li>
            <li>
              Puoi intraprendere un'attività, assumere o cambiare lavoro o
              essere un lavoratore autonomo senza bisogno del permesso di un
              dipartimento governativo.
            </li>
            <li>
              Puoi richiedere la cittadinanza inglese dopo aver vissuto nel
              Regno Unito per un anno da quando ti viene concesso lo status di
              residente.
            </li>
            <li>
              Se hai un figlio nato nel Regno Unito mentre vivi qui, sarà
              automaticamente cittadino inglese.
            </li>
            <li>
              Perderai lo stato di residenza se trascorri 5 anni o più fuori dal
              Regno Unito contemporaneamente (sebbene se sei un cittadino
              svizzero, tu e la tua famiglia potete trascorrere fino a 4 anni
              consecutivi fuori dal Regno Unito prima di perdere lo stato di
              residente).
            </li>
            <li>
              I tuoi parenti stretti possono raggiungerti nel Regno Unito prima
              del 31 dicembre 2020 (o prima del 31 dicembre 2025 se sei
              cittadino svizzero) ma dovranno presentare domanda nell'ambito del
              EU Settlement Scheme (programma di residenza per cittadini UE). Ci
              sono alcune condizioni in base alle quali possono raggiungerti
              dopo il 31 dicembre 2020, ma dovresti scriverci per un consiglio
              specifico su questa domanda.
            </li>
          </ul>

          <p>
            <strong>
              Se richiedi con successo lo stato di residente provvisorio
              (pre-settled), ciò significa che:
            </strong>
          </p>
          <ul>
            <li>Hai il diritto di rimanere nel Regno Unito per cinque anni.</li>
            <li>
              Non è necessario esercitare i diritti dei trattati per rimanere
              nel Regno Unito. Ciò significa che non devi dimostrare di essere
              uno studente, un lavoratore, un lavoratore autonomo, in cerca di
              lavoro o autosufficiente per rimanere nel Regno Unito.
            </li>
            <li>
              Quando sarai stato nel Regno Unito per cinque anni, a condizione
              che non sei stato fuori dal Regno Unito per sei mesi in nessuno di
              questi anni, puoi quindi richiedere lo stato di residenza, anche
              se ciò accade dopo il 31 dicembre 2020.
            </li>
            <li>
              Puoi trascorrere fino a 2 anni consecutivi al di fuori del Regno
              Unito senza perdere il tuo status (anche se dovresti evitare
              assenze di 6 mesi o più se speri di richiedere alla fine lo status
              di residente, a meno che non ci sia un motivo importante per
              l'assenza).
            </li>
            <li>
              Se hai un figlio nel Regno Unito, sarà automaticamente idoneo per
              lo status di residente provvisorio (pre-settled) (in genere sarà
              un cittadino inglese solo se si qualifica per questo tramite
              l'altro genitore che ha la cittadinanza britannica o lo status di
              residente).
            </li>
            <li>
              Non sarai automaticamente idoneo a richiedere benefici o ad
              accedere all'assistenza sanitaria, all'istruzione e alle pensioni
              nel Regno Unito. Devi comunque dimostrare che stai esercitando un
              `` diritto di soggiorno qualificante '', vale a dire che hai lo
              status di residenza permanente, lavoratore dipendente, lavoratore
              autonomo o lavoratore mantenuto, che sei un familiare di un
              cittadino dell'UE in una di queste in pensione o che sei il tutore
              principale di un figlio di un lavoratore nazionale SEE nel settore
              dell'istruzione.
            </li>
          </ul>
        </>
      );
    case "ru":
      return (
        <>
          <p>
            Цель этого приложения - помочь определить, имеете ли вы или ваш
            клиент право подать заявление на получение статуса поселенца или
            предварительного поселенца в соответствии со Схемой Поселенцев ЕС
            (EU Settlement Scheme).
          </p>
          <p>
            <strong>
              Если вы успешно подали заявление на получение статуса поселенца,
              это означает, что:
            </strong>
          </p>
          <ul>
            <li>
              У вас есть право въезжать в Великобританию и выезжать из нее, а
              также постоянно находиться в Великобритании; независимо от того,
              осуществляете ли вы права в отношении международных договоров в
              Великобритании. Это означает, что вам не нужно доказывать, что вы
              студент, работаете, являетесь индивидуальным предпринимателем,
              ищете работу или являетесь самодостаточным лицом, для того чтобы
              оставаться в Великобритании.
            </li>
            <li>
              Вы можете получить доступ и подать заявление на получение
              медицинского обслуживания, образования, пенсий и льгот на тех же
              основаниях, что и граждане Великобритании. К вам будут применяться
              те же требования, что и к гражданину Великобритании, но вам не
              может быть отказано в доступе к таким льготам только на основании
              вашего иммиграционного статуса.
            </li>
            <li>
              Вы можете заниматься бизнесом, устраиваться или менять место
              работы или заниматься индивидуальной трудовой деятельностью без
              разрешения государственного ведомства.
            </li>
            <li>
              Вы можете подать заявление на получение британского гражданства
              после проживания в Великобритании в течение одного года с момента
              получения статуса постоянного поселенца.
            </li>
            <li>
              Если у вас есть ребенок, который родился в Великобритании, пока вы
              живете здесь, он автоматически станет гражданином Великобритании.
            </li>
            <li>
              Вы потеряете свой постоянный статус, если проведете 5 или более
              лет за пределами Великобритании на протяжении одного периода
              (хотя, если вы являетесь гражданином Швейцарии, вы и ваша семья
              можете провести только до 4 лет подряд за пределами
              Великобритании, прежде чем потерять статус поселенца).
            </li>
            <li>
              Ваши близкие родственники могут присоединиться к вам в
              Великобритании до 31 декабря 2020 года (или до 31 декабря 2025
              года, если вы являетесь гражданином Швейцарии), но им необходимо
              будет подать заявление в соответствии с Схемой Поселенцев ЕС (EU
              Settlement Scheme). Существуют определенные условия, при которых
              они могут присоединиться к вам после 31 декабря 2020 года, но вам
              следует связаться с нами отдельно для получения конкретных
              рекомендаций по этому вопросу.
            </li>
          </ul>

          <p>
            <strong>
              Если вы успешно подали заявку на получение статуса
              предварительного поселенца, это означает, что:
            </strong>
          </p>
          <ul>
            <li>
              У вас есть право оставаться в Великобритании в течение пяти лет.
            </li>
            <li>
              Вам не обязательно использовать права в отношении международных
              договоров, чтобы оставаться в Великобритании. Это означает, что
              вам не нужно доказывать, что вы студент, работаете, являетесь
              индивидуальным предпринимателем, ищете работу или являетесь
              самодостаточным лицом, для того чтобы оставаться в Великобритании.
            </li>
            <li>
              Если вы находились в Великобритании в течение пяти лет, и не
              покидали Великобританию на более чем шесть месяцев в любой год из
              этих лет, вы можете подать заявление на получение статуса
              поселенца, даже если этот период наступит после 31 декабря 2020
              года.
            </li>
            <li>
              Вы можете провести до 2 лет подряд за пределами Великобритании, не
              теряя своего статуса (хотя вам следует избегать отсутствия на 6
              месяцев или более, если вы надеетесь в конечном итоге подать
              заявление на получение постоянного статуса, если у вас нет важной
              причины для отсутствия).
            </li>
            <li>
              Если у вас есть ребенок, проживающий в Великобритании, он
              автоматически получит право на предварительное поселение (как
              правило, он будет британским гражданином только в том случае, если
              он имеет право на это через своего другого родителя, который имеет
              британское гражданство или постоянный статус).
            </li>
            <li>
              У вас не будет автоматического право претендовать на пособие или
              доступ к здравоохранению, образованию и пенсиям в Великобритании.
              Вы по-прежнему должны продемонстрировать, что используете
              «соответствующее право на проживание» (‘qualifying right to
              reside’), т.е. что у вас есть постоянное место жительства, статус
              работника, самозанятого или сохраненного работника, что вы
              являетесь членом семьи гражданина ЕС в одной из этих категорий или
              что вы являетесь основным опекуном ребенка работника из ЕЭЗ,
              который еще получает образование.
            </li>
          </ul>
        </>
      );
    case "es":
      return (
        <>
          <p>
            El objetivo de esta aplicación es ayudar a determinar si usted o su
            cliente son elegibles para solicitar el permiso de establecimiento o
            pre-establecimiento bajo el Programa de Establecimiento de la UE.
          </p>
          <p>
            <strong>
              Si usted solicita con éxito el permiso de establecimiento ello
              significa que:
            </strong>
          </p>
          <ul>
            <li>
              Usted tiene el derecho a viajar dentro y fuera del Reino Unido y a
              permanecer permanentemente en el Reino Unido; con independencia de
              si está ejerciendo los derechos conferidos por los tratados en el
              Reino Unido. Esto significa que usted no tiene que demostrar que
              es un estudiante, está trabajando, es trabajador autónomo,
              buscando trabajo o es autosuficiente para permanecer en el Reino
              Unido.
            </li>
            <li>
              Usted puede tener acceso y solicitar asistencia sanitaria,
              educación, pensiones y prestaciones de la misma manera que un
              nacional del Reino Unido. Será sometido a los mismos requisitos de
              elegibilidad que un nacional del Reino Unido, pero no se le podrá
              denegar el acceso a dichas prestaciones solamente sobre la base de
              su estátus de inmigración.
            </li>
            <li>
              Usted puede hacer negocios, asumir o cambiar de trabajo, o ser
              autónomo sin necesidad de solicitar el permiso de un departamento
              del Gobierno.
            </li>
            <li>
              Usted puede solicitar la ciudadanía británica después de vivir en
              el Reino Unido durante un año a contar desde que se le concedió el
              permiso de establecimiento.
            </li>
            <li>
              Si durante el tiempo que viva en Reino Unido usted tiene un hijo
              nacido aquí, automáticamente será ciudadano británico.
            </li>
            <li>
              Usted perderá su permiso de establecimiento si permanece 5 años o
              más fuera del Reino Unido de una vez (aunque si es usted un
              ciudadano suizo, usted y su familia solo podrán pasar 4 años
              consecutivos fuera del Reino Unido antes de perder su permiso de
              residencia).
            </li>
            <li>
              Sus familiares cercanos podrán reunirse con usted en el Reino
              Unido antes del 31 de diciembre de 2020 (o antes del 31 de
              diciembre de 2025 si es usted un ciudadano suizo) pero ellos
              tendrán que hacer su solicitud bajo el Programa de Establecimiento
              de la UE. Hay ciertas condiciones bajo las que podrán reunirse con
              usted después del 31 de diciembre de 2020, pero debería
              escribirnos para obtener asesoramiento específico sobre esta
              cuestión.
            </li>
          </ul>

          <p>
            <strong>
              Si usted solicita con éxito el permiso de residencia limitado ello
              significa que:
            </strong>
          </p>
          <ul>
            <li>
              Usted tiene el derecho a permanecer en el Reino Unido durante 5
              años.
            </li>
            <li>
              Usted no tiene que estar ejercitando los derechos conferidos por
              los tratados para permanecer en el Reino Unido. Esto significa que
              usted no tiene que demostrar que es estudiante, que está
              trabajando, es autónomo, buscando trabajo o autosuficiente para
              permanecer en el Reino Unido.
            </li>
            <li>
              Cuando usted haya estado en el Reino Unido durante 5 años, siempre
              que no haya permanecido fuera del Reino Unido durante 6 meses en
              cualquiera de esos años, puede entonces solicitar el permiso de
              residencia indefinido, aún cuando ello ocurra después del 31 de
              diciembre de 2020.
            </li>
            <li>
              Usted puede permanecer hasta 2 años consecutivos fuera del Reino
              Unido sin perder su permiso (aunque debería evitar ausencias de 6
              meses o más si espera poder solicitar en algún momento el permiso
              de residencia permanente, a no ser que haya una razón de peso para
              la ausencia).
            </li>
            <li>
              Si tiene un hijo en el Reino Unido, será automáticamente elegible
              para el permiso de residencia limitado (generalmente solo será un
              ciudadano británico si reúnen los requisitos para ello a través de
              su otro progenitor, que tendrá la ciudadanía británica o permiso
              de residencia indefinido por sí mismo).
            </li>
            <li>
              Usted no será automáticamente elegible para reclamar prestaciones
              o para acceder a la sanidad, educación o pensiones en el Reino
              Unido. Deberá demostrar que está ejercitando un 'derecho a residir
              cualificado', es decir, que usted tiene el estátus de residencia
              permanente, de trabajo, de trabajador autónomo o el retenido de
              trabajo, que es usted pariente de un nacional de la UE
              perteneciente a una de estas categorías, o que es usted el
              cuidador principal del hijo de un nacional del EEE que esté en
              edad escolar.
            </li>
          </ul>
        </>
      );
    case "hi":
      return (
        <>
          <p>
            इस एप्लिकेशन का उद्देश्य यह स्थापित करने में मदद करना है कि क्या आप
            या आपके ग्राहक यूरोपीय संघ निपटान योजना के तहत बसे हुए स्थिति या
            पूर्व-निर्धारित स्थिति के लिए आवेदन करने के योग्य हैं।
          </p>
          <p>
            <strong>
              यदि आप सफलतापूर्वक बसे हुए स्थिति के लिए आवेदन करते हैं तो इसका
              मतलब है कि:
            </strong>
          </p>
          <ul>
            <li>
              आपको यूके में और बाहर यात्रा करने और स्थायी रूप से यूके में रहने
              का अधिकार है; चाहे आप ब्रिटेन में संधि अधिकारों का प्रयोग कर रहे
              हों। इसका मतलब है कि आपको यह प्रदर्शित करने की आवश्यकता नहीं है कि
              आप ब्रिटेन में रहने के लिए एक छात्र, कामकाजी, स्वरोजगार, नौकरी की
              तलाश या आत्मनिर्भर हैं।
            </li>
            <li>
              आप यूके के राष्ट्रीय स्तर पर स्वास्थ्य सेवा, शिक्षा, पेंशन और लाभ
              के लिए आवेदन कर सकते हैं। आप ब्रिटेन की राष्ट्रीय के रूप में एक ही
              पात्रता आवश्यकताओं के अधीन होंगे, लेकिन अकेले आपकी आव्रजन स्थिति
              के आधार पर ऐसे लाभों तक पहुंच से इनकार नहीं किया जा सकता है।
            </li>
            <li>
              आप व्यवसाय में संलग्न हो सकते हैं, रोजगार ले सकते हैं या बदल सकते
              हैं, या सरकारी विभाग की अनुमति के बिना स्वरोजगार कर सकते हैं।
            </li>
            <li>
              आप ब्रिटेन में रहने के बाद ब्रिटिश नागरिकता के लिए आवेदन कर सकते
              हैं जब से आपको एक वर्ष के लिए दिया जाता है।
            </li>
            <li>
              यदि आपके पास एक बच्चा है जो यूके में पैदा हुआ है जबकि आप यहां रह
              रहे हैं, तो वे स्वचालित रूप से एक ब्रिटिश नागरिक होंगे।
            </li>
            <li>
              यदि आप एक समय में यूके में 5 साल या उससे अधिक समय बिताते हैं, तो
              आप अपना बसेरा खो देंगे (हालांकि यदि आप एक स्विस नागरिक हैं, तो आप
              और आपका परिवार केवल यूके खोने से पहले 4 साल तक की अवधि तक खर्च कर
              सकते हैं। बसा हुआ दर्जा)।
            </li>
            <li>
              आपके करीबी परिवार के सदस्य 31 दिसंबर 2020 से पहले (या 31 दिसंबर
              2025 से पहले अगर आप स्विस नागरिक हैं) यूके में आपसे जुड़ सकते हैं,
              लेकिन उन्हें ईयू सेटलमेंट स्कीम के तहत आवेदन करना होगा। ऐसी कुछ
              शर्तें हैं, जिनके तहत वे 31 दिसंबर 2020 के बाद आपसे जुड़ सकते हैं,
              लेकिन आपको इस सवाल पर विशेष सलाह के लिए हमें लिखना चाहिए।
            </li>
          </ul>

          <p>
            <strong>
              यदि आप सफलतापूर्वक पूर्व-बसे हुए स्थिति के लिए आवेदन करते हैं तो
              इसका मतलब है कि:
            </strong>
          </p>
          <ul>
            <li>आपको यूके में पांच साल तक रहने का अधिकार है।</li>
            <li>
              आपको यूके में बने रहने के लिए संधि अधिकारों का प्रयोग करने की
              आवश्यकता नहीं है। इसका मतलब है कि आपको यह प्रदर्शित करने की
              आवश्यकता नहीं है कि आप ब्रिटेन में रहने के लिए एक छात्र, कामकाजी,
              स्वरोजगार, नौकरी की तलाश या आत्मनिर्भर हैं।
            </li>
            <li>
              जब आप यूके में पांच साल के लिए रहे हैं, जब तक कि आप इनमें से किसी
              भी साल में छह महीने के लिए यूके के बाहर नहीं रहे हैं, तब तक आप बसे
              हुए स्थिति के लिए आवेदन कर सकते हैं, भले ही यह 31 दिसंबर 2020 के
              बाद हो।
            </li>
            <li>
              आप अपनी स्थिति को खोए बिना यूके के बाहर एक पंक्ति में 2 साल तक का
              समय बिता सकते हैं (हालांकि आपको 6 महीने या उससे अधिक की अनुपस्थिति
              से बचना चाहिए, यदि आप अंततः बसे हुए स्थिति के लिए आवेदन करने की
              उम्मीद करते हैं, जब तक कि अनुपस्थिति का एक महत्वपूर्ण कारण न हो)।
            </li>
            <li>
              यदि आपके पास यूके में एक बच्चा है, तो वे स्वचालित रूप से पूर्व-बसे
              हुए स्थिति के लिए पात्र होंगे (वे आम तौर पर केवल एक ब्रिटिश नागरिक
              होंगे यदि वे अपने अन्य माता-पिता के माध्यम से इसके लिए अर्हता
              प्राप्त करते हैं, जिनके पास ब्रिटिश नागरिकता है या स्वयं स्थिति
              निर्धारित है)।
            </li>
            <li>
              आप स्वचालित रूप से यूके में लाभ या स्वास्थ्य सेवा, शिक्षा और पेंशन
              का दावा करने के लिए पात्र नहीं होंगे। आपको अभी भी प्रदर्शित करना
              चाहिए कि आप 'निवास करने के लिए योग्य अधिकार' का प्रयोग कर रहे हैं
              यानी आपके पास स्थायी निवास, कार्यकर्ता, स्व-नियोजित या अनुरक्षित
              कर्मचारी का दर्जा है, कि आप इन श्रेणियों में से किसी एक में
              यूरोपीय संघ के राष्ट्रीय परिवार के सदस्य हैं, या वह आप शिक्षा में
              एक ईईए राष्ट्रीय कार्यकर्ता के बच्चे के प्राथमिक देखभालकर्ता हैं।
            </li>
          </ul>
        </>
      );

    default:
      break;
  }
};

export default Intro2;
